export const topLiveGames: string[] = [
  'top_games',
  'game_shows',
  'poker',
  '104',
  '105',
  'monopoly:sk4zk6p4lr4quhcl',
  'crazytime:sk4zk6p5lr4quhcx',
  'monopolybigballer:sk4zk6p4lr4quhb4',
  'americanroulette:sk4zk6p4lr4quhcg',
  'funkytime:sk4zk6p4lr4quhcs',
  'gonzotreasuremap:sk4zk6lslr4qug57',
  'balloonrace:BalloonRace00001',
  'sicbo:sk4zk6p4lr4quhce',
  'topdice:sk4zk6p3lr4quhbl',
  'extrachilliepicspins:sk4zk6p3lr4quhb3',
  'crazycoinflip:sk4zk6p3lr4quhbv',
  'roulette:sk4zk6p6lr4quhc7',
  'reddoorroulette:sk4zk6lslr4qug6f',
  'videopoker:sk4zk6lslr4qug6a',
  'crazytime:sk4zk6p3lr4quhbz',
  'baccarat:sk4zk6lslr4qug54',
  'topcard:sk4zk6p4lr4quhcb',
  'lightningstorm:LightningStorm01',
  'roulette:sk4zk6p4lr4quhcq',
  'stockmarket:sk4zk6pllr4quhaw',
  'deadoralivesaloon:sk4zk6p3lr4quhbn',

  '1101',
  'pragmaticexternal:SweetBonanzaCandyland',

  'videopoker:VPTable000000001',

  'monopoly:phtnjtrbp4ewwlei',

  'game_shows',
  'crazytime:qqkjdqdrf4mdim4u',
  '204',
  'pragmaticexternal:MegaRoulette',
  '801',
  'pragmaticexternal:MegaWheel',
  '103',

  'pragmaticexternal:BlackjackLobby',
  'rng-roulette:rng-rt-xxxtreme1',
  'Blackjack',
  '545',
  'pragmaticexternal:Roulette9TheClub',
  '230',
  '701',
  'pragmaticexternal:MegaSicBo',
  '902',
  '901',
  'pragmaticexternal:ONEBlackjack',
  '1401',
  'pragmaticexternal:BoomCity',
  'dealnodeal:onentf7hvekqqdll',
  'crazycoinflip:CrazyCoinFlip001',
  'blackjack:q6wo6ghvrnlhuhjd',
  'baccarat:phvx7wgwp4ez6rqj',
  'blackjack:puh4vrnhmg2uzvvv',
  'blackjack:ptszy32umaed5pzb',
]
